// // import * as angular from 'angular';

export const DocumentProductTaxesExonerationsComponent = {
  templateUrl:
    './app/ajs/_shared/components/document-product-taxes-exonerations/document-product-taxes-exonerations.component.html',
  bindings: {
    documentProduct: '<',
    currency: '<',
    scopeType: '<',
    onDocumentProductTaxesExonerationsSaved: '&',
    onDocumentProductTaxesExonerationsCanceled: '&',
  },
  controller: DocumentProductTaxesExonerationsController,
  controllerAs: 'vm',
};

DocumentProductTaxesExonerationsController.$inject = [
  'UtilService',
  'SessionService',
  'moment',
  'ModalWindowConfirmService',

  // Angular downgraded service
  'countryService',
];

function DocumentProductTaxesExonerationsController(
  UtilService,
  SessionService,
  moment,
  ModalWindowConfirmService,

  // Angular downgraded service
  countryService
) {
  const vm = this;

  // public properties
  // -----------------------
  vm.UtilService = new UtilService(vm);

  vm.listMode = true;
  vm.detailMode = false;
  // vm.viewMode = false;
  vm.taxExonerationSelected = null;

  // private properties
  // -----------------------
  let company = SessionService.getSelectedAccountCompany();

  let userLanguageCode = SessionService.getUserLanguage().code;

  vm.dateDisplay = userLanguageCode !== 'es' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';

  vm.$onInit = function () {
    // console.log(vm.documentProduct);

    // Initializers
    setDateOptions();
    getExonerationTypes(company.country.code);
  };

  // public methods
  // -----------------------
  vm.addDocumentProductTaxExoneration = function (tax) {
    vm.listMode = false;
    vm.detailMode = true;

    vm.createMode = true;

    vm.taxSelected = tax;

    vm.taxExonerationSelected = {
      tax_id: tax.tax_id,
      date: '',
    };

    vm.taxSelected.exoneration = vm.taxExonerationSelected;
  };

  vm.editDocumentProductTaxExoneration = function (tax, mode) {
    vm.listMode = false;
    vm.detailMode = true;

    vm.createMode = false;
    vm.editMode = false;
    vm.viewMode = true;

    if (mode === 'edit') {
      vm.editMode = true;
      vm.viewMode = false;
    }

    vm.taxSelected = tax;
    vm.taxExonerationSelected = tax.exoneration;

    vm.taxExonerationSelected.date = moment(vm.taxExonerationSelected.date);

    vm.originalTaxExonerationSelected = angular.copy(tax.exoneration);
  };

  vm.deleteDocumentProductTaxExoneration = function (tax, index) {
    let confirmCallback = () => {
      tax.exoneration = null;

      // TODO: what about costs ??

      // sale_taxes
      // purchase_taxes

      // let taxes = vm.documentProduct.productTaxes || vm.documentProduct.sale_taxes;

      // try only with vm.documentProduct.transaction_taxes on invoice detail
      // vm.documentProduct.transaction_taxes = TaxService.setProductTaxesAmounts(vm.documentProduct.subtotal_price, taxes);

      vm.onDocumentProductTaxesExonerationsSaved({ item: vm.documentProduct });
    };

    let modalParams = {
      title: 'DELETE_EXONERATION',
      body: 'SURE_TO_DELETE_EXONERATION',
      mode: 'danger',
    };

    ModalWindowConfirmService.open(modalParams, confirmCallback);
  };

  // Create/Update
  vm.saveDocumentProductTaxExoneration = function (isFormValid) {
    if (!isFormValid) return;

    vm.listMode = true;
    vm.detailMode = false;

    if (vm.createMode) {
      vm.taxExonerationSelected.exonerationType = vm.exonerationTypes.find(
        (item) => item.code === vm.taxExonerationSelected.exoneration_type_code
      ); // .name
      vm.taxExonerationSelected.date = moment(vm.taxExonerationSelected.date);
    }

    // TODO: what about costs

    // sale_taxes
    // purchase_taxes

    // check once updates

    // let taxes = vm.documentProduct.productTaxes || vm.documentProduct.sale_taxes;

    // vm.documentProduct.transaction_taxes = TaxService.setProductTaxesAmounts(vm.documentProduct.subtotal_price, taxes);

    vm.onDocumentProductTaxesExonerationsSaved({ item: vm.documentProduct });
  };

  vm.cancel = function () {
    vm.onDocumentProductTaxesExonerationsCanceled();
  };

  vm.goExonerationList = function () {
    vm.listMode = true;
    vm.detailMode = false;

    if (vm.originalTaxExonerationSelected) {
      // We need to update the object properties insted of the object
      vm.taxExonerationSelected.exonerationType = vm.originalTaxExonerationSelected.exonerationType;
      vm.taxExonerationSelected.document_number = vm.originalTaxExonerationSelected.document_number;
      vm.taxExonerationSelected.institution_name =
        vm.originalTaxExonerationSelected.institution_name;
      vm.taxExonerationSelected.date = vm.originalTaxExonerationSelected.date;
      vm.taxExonerationSelected.percentage = vm.originalTaxExonerationSelected.percentage;
    } else {
      vm.taxExonerationSelected = null;
      vm.taxSelected.exoneration = null;
    }
  };

  // private methods
  // -----------------------
  function setDateOptions() {
    let onChangeDate = () => {};

    vm.dateOptions = vm.UtilService.singleDatePickerOptions({
      // minDate: moment().subtract(3, 'years'), // en fecha de emsion hay que poner la fecha de creacion de la ley y es de 1962 y el sistama no permite esto
      maxDate: moment(),
      showDropdowns: true,
      dateDisplay: vm.dateDisplay,
      onChangeDate: onChangeDate,
    });
  }

  function getExonerationTypes(code) {
    let params = {
      country_code: code.toLowerCase(),
      skip_check_role: true,
      lang: userLanguageCode,
    };

    vm.loadingExonerationTypes = true;
    countryService.getExonerationTypesByCountry(params).subscribe((response) => {
      vm.exonerationTypes = response;

      vm.documentProduct.transaction_taxes.forEach((tax) => {
        if (tax.exoneration) {
          tax.exoneration.exonerationType = vm.exonerationTypes.find(
            (item) => item.code === tax.exoneration.exoneration_type_code
          ); // name
        }
      });

      vm.loadingExonerationTypes = false;
    });
  }
}
